<template>
  <div>
    <div>
      <v-flex justify="center" v-if="Data.length!=0">

<!-- {{Data.slice(3, 7).map(X =>  Number(X.answer))}} -->
<!-- <BarReady :nameLabel="Name" :labels="Q.slice(3, 7).map(Q=> Q.Q)" :dataset="Data.slice(3, 7).map(X =>  Number(X.answer))" /> -->
   <v-data-table
    :headers="headers"
    :items="Info"
    item-key="question"
    class="elevation-1"
  >
    <template v-slot:items="props">
      <td class="text-xs-right">{{ props.item.question}}</td>
      <td class="text-xs-right">{{getTexts( props.item.T,props.item.answer) }}</td>
    </template>
  </v-data-table>
<!-- {{Data}} -->

      </v-flex>
    </div>
    
  </div>
</template>

<script>
import BarReady from './BarReady.vue';
// import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BarReady
  },
  props:
  {
    Data: Array,
    Name: String,
  },
  computed: {
  },
    created(){
        for (let i = 0; i < this.Data.length; i++) {
    this.Info.push({question: this.Data[i].question,T: this.Data[i].T,  answer: this.Data[i].answer})
    
  }
  // for (let i = 0; i < this.Data.answers.length; i++) {
  //   this.Info.push({question: this.Questions[i].Q, answer: this.Data.answers[i]})
    
  // }
  
// Vue.set(vm.items, indexOfItem, newValue)

  // this.Info.splice(0, 1, this.Info.splice[0])
//   let itemIndex =0
// // let editedItem = { ...this.playlist[itemIndex], ...{ tuning: tuning, url: url } };
// this.Info.splice(itemIndex, 1, itemIndex)
  },
  methods: {
   
   getTexts( textType,Place){
  if (textType=="Good") {
    return this.Good[Number(Place)]
  }
    else if (textType=="Goals") {
    return this.Goals[Number(Place)]
  }
    else if (textType=="Age") {
    return this.Age[Number(Place)]
  }
    else if (textType=="Working") {
    return this.Working[Number(Place)]
  }
    else if (textType=="Working2") {
    return this.Working2[Number(Place)]
  }
  //     else if (textType=="Elementary") {
  //   return this.Elementary
  // }
},
  },
  data() {
    return {
                Good: [
          "Bra",
          "Mindre bra",
          "Vet ej"
        ],
                Goals: [
          "Når målen",
          "Når ej målen",
          "Vet inte"
        ],
                Age: [
          "Åldersadvekat",
          "Icke åldersadvekat",
          "Vet inte"
        ],
                Working: [
          "Huvudsakligen fungerande",
          "Ej fungerande",
          "Vet inte"
        ],
            Working2: [
          "Huvudsakligen fungerande och uppfyller målen",
          "Huvudsakligen fungerande",
          "Ej fungerande",
          "Vet inte"
        ],
      headers:[
                      { 
          text: "Fråga",
          align: "start",
          value: "question",
        },
              { 
          text: "Svar",
          align: "start",
          value: "answer",
        }
        ],
      Info: [],
     
    };
  },
};
</script>

<style scoped>


</style>